import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { LuBookOpenCheck, LuTicket, LuGift } from "react-icons/lu";
import StarIcon from "../ui/StarIcon";
import * as styled from "./StarsIntro.styled";

const STORAGE_KEY = "starsIntroSeen";

const wasSeen = () => {
  try {
    return window.localStorage.getItem(STORAGE_KEY) === "1";
  } catch (error) {
    return true; // сховище недоступне — не набридаємо вікном щоразу
  }
};

const POINTS = [
  { Icon: LuBookOpenCheck, text: "+1 зірка за кожне здане домашнє завдання" },
  { Icon: LuTicket, text: "Обмінюй на знижки та безкоштовні уроки" },
  { Icon: LuGift, text: "Даруй друзям пробні уроки" },
];

// Одноразове вікно-знайомство із зірками для учня
function StarsIntro({ stars = 0 }) {
  const navigate = useNavigate();
  const [open, setOpen] = useState(() => !wasSeen());

  const close = () => {
    try {
      window.localStorage.setItem(STORAGE_KEY, "1");
    } catch (error) {}
    setOpen(false);
  };

  if (!open) return null;

  return (
    <styled.Overlay onClick={close}>
      <styled.Modal role="dialog" aria-modal="true" onClick={(event) => event.stopPropagation()}>
        <styled.Hero>
          <styled.HeroStar>
            <StarIcon size={64} />
          </styled.HeroStar>
          <styled.HeroLabel>Нова фіча</styled.HeroLabel>
          <styled.Title>Тепер у Speaksy є зірки!</styled.Title>
          {stars > 0 && (
            <styled.Gift>
              Тобі вже нараховано <b>{stars}</b> <StarIcon size={18} /> на старт
            </styled.Gift>
          )}
        </styled.Hero>
        <styled.Body>
          {POINTS.map(({ Icon, text }) => (
            <styled.Point key={text}>
              <styled.PointIcon>
                <Icon size={18} />
              </styled.PointIcon>
              {text}
            </styled.Point>
          ))}
          <styled.Primary
            onClick={() => {
              close();
              navigate("/student/shop");
            }}
          >
            До магазину
          </styled.Primary>
          <styled.Secondary onClick={close}>Пізніше</styled.Secondary>
        </styled.Body>
      </styled.Modal>
    </styled.Overlay>
  );
}

export default StarsIntro;
